export default __webpack_public_path__ + "62e5a2271e8f1e2602bd354718f132f5.png";